import React, {useContext} from "react"

// context, config and utils
import {ShopContext} from "../../../context/ShopContext"
import config from "../../../config"
import Storage from "../../../data/storage"

// components
import {Link} from "../../controls"

// styling and images
import "./CheckoutNavigator.scss"

const ordinals = {
  cart:"1",
  packaging:"2",
  personalize:"3",
  payment:"4",
  confirm:"5"
}

// the component
function CheckoutNavigator({stepName}) {
  // context
  let shop = useContext(ShopContext)

  // get the step and set progress
  let step = config.checkoutSteps.find(s => s.key === stepName)
  Storage.setCheckoutProgress(step.index)

  // the checkout progress is not always the same as step.index ... so get from storage
  let checkoutProgress = Storage.getCheckoutProgress()
  
  // render links
  const links = config.checkoutSteps
    .sort((a,b) => a.index > b.index ? 1:-1)
    .map((s, index) => {
      let isActive = stepName === s.key
      let isValid = true
      let isDisabled = s.index > checkoutProgress
      let isCompleted = checkoutProgress >= index
      
      // TODO #NotDry we check for validity here and in checkout/console ... 
      
      switch(s.key) {
        case "cart":
          isValid = true 
          break
        case "personalize":
          isValid = shop.cartValidation.personalization
          break
        case "payment":
          isValid = shop.cartValidation.payment
          break
        case "confirm":
          break
        default:
          break
      }

    // css depending on state
    let classNames = ["item"]
    if(!isValid && !isActive) {
      classNames.push("invalid")
    }
    else if(isCompleted) {
      classNames.push("completed")
    }

    // render
    let indicator = isActive ? <span className="indicator" /> : null
    let inner = (
      <>
      <span className="ordinal">{ordinals[s.key]}</span>
      {indicator}
      </>
    )
    if(isDisabled) {
      classNames.push("disabled")
      return (
        <div key={s.key} className={classNames.join(" ")}>
          {inner}
        </div>
      )
    }
    else {
      return (  
        <Link key={s.key} to={`/checkout/${s.key}`}>
          <div className={classNames.join(" ")}>
            {inner}
          </div>
        </Link>
      )
    }
  })

  return (
    <div id="s-checkoutnavigator">
      {links}
    </div>
  )
}

export default CheckoutNavigator